import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";

const customStyles = {
	overlay: {
		zIndex: 1200,
	},
};

const ImageLightBox = (props) => {
	const [photoIndex, setPhotoIndex] = useState(0);
	const { images, isOpen, hideLightBox } = props;

	useEffect(() => {
		setPhotoIndex(props.photoIndex);
	}, [props.photoIndex]);

	const handleKeydown = (e) => {
		//Left arrow
		if (e.keyCode === 37) {
			setPhotoIndex((photoIndex + images.length - 1) % images.length);
		}
		//Right arrow
		if (e.keyCode === 39) {
			setPhotoIndex((photoIndex + 1) % images.length);
		}
	};

	useEffect(() => {
		document.getElementsByClassName("ReactModalPortal")[0]?.addEventListener("keydown", handleKeydown);
		window.addEventListener("keydown", handleKeydown);

		return () => {
			document.getElementsByClassName("ReactModalPortal")[0]?.removeEventListener("keydown", handleKeydown);
			window.removeEventListener("keydown", handleKeydown);
		};
	}, [photoIndex]);

	return (
		<>
			{isOpen && (
				<Lightbox
					ariaHideApp={true}
					mainSrc={images[photoIndex] && images[photoIndex].fullUrl ? images[photoIndex].fullUrl : images[photoIndex]}
					nextSrc={
						images.length > 1
							? images[(photoIndex + 1) % images.length]?.fullUrl
								? images[(photoIndex + 1) % images.length].fullUrl
								: images[(photoIndex + 1) % images.length]
							: false
					}
					prevSrc={
						images.length > 1
							? images[(photoIndex + images.length - 1) % images.length]?.fullUrl
								? images[(photoIndex + images.length - 1) % images.length].fullUrl
								: images[(photoIndex + images.length - 1) % images.length]
							: false
					}
					imageCaption={images.length > 1 ? `Hình ${photoIndex + 1} / ${images.length}` : false}
					onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
					onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
					onCloseRequest={hideLightBox}
					reactModalStyle={customStyles}
				/>
			)}
		</>
	);
};

export default ImageLightBox;
